
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-1d2cf838\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?-autoprefixer&sourceMap!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-1d2cf838\",\"scoped\":false,\"hasInlineConfig\":false}!postcss-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./App.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1d2cf838\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/App.vue
// module id = 550
// module chunks = 1